// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Currency from "../../../../../library/data-source/country-currency/Currency.bs.js";

function getSlabFromString(slab) {
  switch (slab) {
    case "Diamond" :
        return /* Diamond */2;
    case "Gold" :
        return /* Gold */1;
    case "Platinum" :
        return /* Platinum */3;
    case "Silver" :
        return /* Silver */0;
    default:
      return ;
  }
}

function getStringFromSlab(slab) {
  if (slab === undefined) {
    return "";
  }
  switch (slab) {
    case /* Silver */0 :
        return "Silver";
    case /* Gold */1 :
        return "Gold";
    case /* Diamond */2 :
        return "Diamond";
    case /* Platinum */3 :
        return "Platinum";
    
  }
}

var default_slab = /* Silver */0;

var default_offered = Currency.toCurrency(0.0);

var default_redeemed = Currency.toCurrency(0.0);

var default_balance = Currency.toCurrency(0.0);

var $$default = {
  slab: default_slab,
  offered: default_offered,
  redeemed: default_redeemed,
  balance: default_balance
};

export {
  getSlabFromString ,
  getStringFromSlab ,
  $$default ,
  $$default as default,
  
}
/* default Not a pure module */
